import Request from './RequestHandler.js'

export default {
  authenticate (params) {
    return Request.make('post', 'authenticate', params)
  },
  refreshToken (params) {
    return Request.make('post', 'renew-token', params)
  }
}
